exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h-full[data-v-22c81eaa]{height:100%}.w-full[data-v-22c81eaa]{width:100%}.p-10px[data-v-22c81eaa]{padding:10px}.bg-\\[\\#fff\\][data-v-22c81eaa]{background:#fff}.\\!w-150px[data-v-22c81eaa]{width:150px!important}.mr-10px[data-v-22c81eaa]{margin-right:10px}.mb-10px[data-v-22c81eaa]{margin-bottom:10px}.mt-10px[data-v-22c81eaa]{margin-top:10px}", ""]);

// exports
